import { PM_PROVIDERS } from 'common/constants/constants';
import { getCustomFieldsItems } from 'components/FilterMenus/FilterMenus.service';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';

// get custom fields mapper from DDB
const useCustomFieldsMapper = () => {
  const pmSensor = useSelector(pmIntegrationSelector) || {};
  const sensorId = pmSensor?.sensor_id || PM_PROVIDERS.JIRA;

  const [customFieldsById, setCustomFieldsById] = useState({});
  const [customFieldsByName, setCustomFieldsByName] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchCustomFields = async () => {
    try {
      setIsLoading(true);
      const customFieldsItems = await getCustomFieldsItems({
        sensorId,
        supportAllFields: true
      });
      const customFieldsById =
        customFieldsItems?.reduce((acc, field) => {
          acc[field.id] = field.title;
          return acc;
        }, {}) || {};
      const customFieldsByName =
        customFieldsItems?.reduce((acc, field) => {
          acc[field.title] = field.id;
          return acc;
        }, {}) || {};
      setCustomFieldsById(customFieldsById);
      setCustomFieldsByName(customFieldsByName);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomFields();
  }, []);

  return {
    customFieldsById,
    customFieldsByName,
    isLoading
  };
};

export default useCustomFieldsMapper;
